"use client";

import { useEffect } from "react";

import { USE_EZOIC } from "shared-lib/constants";

import Ad from "@/components/ad";
import EzoicVideoPlayer from "@/components/ezoicVideoPlayer";
import { GlobalActionTypes, useGlobalState } from "@/context/globalState";
import { PAGE_NAMES } from "@/lib/constants";

export default function RecipeSlugConditionalVideoPlayer() {
  const [, dispatch] = useGlobalState();

  useEffect(() => {
    dispatch({
      type: GlobalActionTypes.SET_VISITED_PAGE,
      payload: PAGE_NAMES.RECIPE,
    });
  }, [dispatch]);

  return USE_EZOIC ? (
    <div className="mx-0 my-4 flex flex-wrap items-center justify-around gap-1">
      <Ad
        id="ezoic_160"
        className="mx-auto w-full md:hidden"
        ezoicId="160"
        useWithPartner="EZOIC"
      />

      <EzoicVideoPlayer />
    </div>
  ) : null;
}
